enum ModalTypeEnum {
    NONE = '',
    FAST_TRACK_MENU = 'FAST_TRACK_MENU'
}

export default ModalTypeEnum
